export default __webpack_public_path__ + "static/media/Lateral_Right_Male_.17d1d6b0.png";